import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import $ from 'jquery';
import DropDownMenu from './DropDownMenu';
import { textInputOnChange } from '../commonJS/onFormChanges';
import { numberHandler } from '../commonJS/addCommasToNumber';

import {
	Well, Row, Col, FormGroup, ControlLabel,
	FormControl, Button
} from 'react-bootstrap';


export default class PartsSearchAreaCt extends React.PureComponent {
	constructor(props) {
		super(props);

		this.handlers = {
			textInputOnChange: e => {
				textInputOnChange(e, this);
			},
			dropDownOnChange: (selection, id) => {
				if (this.props.onAddToPartsType === 'shippingRecords') this.setState({ selectedShippingRecord: selection });
				else {
					if (selection.disable_date) { alert('產品已停用'); return; }
					else this.setState({ selectedPart: selection });
				};
			},
			onAddToParts: () => {
				const { selectedPart, selectedShippingRecord } = this.state;

				if (this.props.onAddToPartsType === 'shippingRecords') {
					this.props.onAddToParts(selectedShippingRecord);
				} else {
					this.props.onAddToParts(selectedPart);

					this.focusGivenField();
				}

				this.setState({
					selectedPart: '',
					selectedShippingRecord: '',
					partId: '',
					partName: '',
					partSpec: ''
				});

			},
			searchPartsRealTime: () => {
				this.setState({ dropDownPlaceholder: '查詢中…', selectedPart: '' });

				let paraObj = {};
				if (this.state.partId) paraObj.product_id = this.state.partId;
				if (this.state.partName) paraObj.spec = this.state.partName;
				// if (this.state.partSpec) paraObj.part_spec = this.state.partSpec;

				$.ajax({
					type: 'GET',
					url: '/api/M_Product_Jnh_Search_Get.php',
					data: paraObj,
					complete: xhr => {
						const data = xhr.responseJSON;

						let partsInfo = '', optsSearchResults = [];
						switch (data.status) {
							case '0':
								optsSearchResults = this.optsGenerator(data.result);
								// part_id: x.number.part_id, part_name: x.name, label:  x.number.part_id + ' - ' + x.name, price: x.price, part_spec: x.part_spec
								partsInfo = '請點擊以選擇零件。';
								break;
							case '404':
								partsInfo = '查無零件資料。';
								break;
							case '447':
								partsInfo = '符合項目數量過多，請描述的更具體。';
								break;

							default:
						}

						this.setState({ dropDownPlaceholder: partsInfo, optsSearchResults }, () => {
							if (optsSearchResults.length > 0) $('#part-search-results-dropdown').focus();
						});
					}
				});

			}
		};

		this.focusGivenField = selector => {
			const state = this.state;
			if (!selector) {
				if (state.partId) selector = '#partId';
				else if (state.partName) selector = '#partName';
				// else if (state.partSpec) selector = '#partSpec';
				else selector = '#partId';
			}

			$(selector).focus();
		};

		this.optsGenerator = (arrObj) => {
			if (!arrObj) return [];
			let opts;
			if (this.props.onAddToPartsType === 'shippingRecords') {
				opts = arrObj.map((item, ind) => {
					return {
						label: `${item.doc_id}`,
						...item
					};
				});
			} else {
				opts = arrObj.map((item, ind) => {
					return {
						label: `${item.product_id} / ${item.spec} / ${numberHandler(item.list_price ? item.list_price * 1 : '0')} / ${numberHandler(item.purchase_price ? item.purchase_price * 1 : '0')} / ${item.disable_date ? moment(item.disable_date).format('YYYY-MM-DD HH:mm') : item.disable_date}`,
						...item
					};
				});
			}
			return opts;
		};

		this.state = {
			partId: '',
			partName: '',
			partSpec: '',
			supplierName: '',
			optsSearchResults: [],
			optsSearchResults_shippingRecords: [],
			selectedPart: '',
			selectedShippingRecord: '',
			dropDownPlaceholder: '請在上方輸入資料查詢，查詢結果會於此展開。'
		};
	}

	componentDidMount() {
		if (this.props.onAddToPartsType === 'shippingRecords') {
			$.ajax({
				type: 'GET',
				url: '/api/M_Lading_Data_Search_Get.php',
				complete: xhr => {
					const data = xhr.responseJSON;

					let partsInfo = '', optsSearchResults_shippingRecords = [];
					switch (data.status) {
						case '0':
							optsSearchResults_shippingRecords = this.optsGenerator(data.result);
							partsInfo = '請點擊以選擇零件。';
							break;
						case '404':
							partsInfo = '查無零件資料。';
							break;
						case '447':
							partsInfo = '符合項目數量過多，請描述的更具體。';
							break;

						default:
					}

					this.setState({ dropDownPlaceholder: partsInfo, optsSearchResults_shippingRecords });
				}
			});
		}

		$("#partId, #partName, #partSpec").keydown(e => {
			if (e.keyCode === 13) {
				// if (this.state.partId === '' && this.state.partName === '' && this.state.partSpec === '') {
				if (this.state.partId === '' && this.state.partName === '') {
					this.setState({ dropDownPlaceholder: '搜尋內容不可空白' });
					return;
				}

				this.handlers.searchPartsRealTime();
			}
		});

		this.focusGivenField('#partId');
	}

	render() {
		const { languageData, languageCode } = window.myConsts;

		const props = this.props, state = this.state, handlers = this.handlers;

		let editable = true;

		return (
			<Well>
					{
						props.onAddToPartsType === 'shippingRecords' ?
							<Row>
								<DropDownMenu
									sm={12}
									label={`${languageData['444'][languageCode]} (領貨單編號)`}
									options={state.optsSearchResults_shippingRecords}
									onChange={handlers.dropDownOnChange}
									valueKey='doc_id'
									value={state.selectedShippingRecord.doc_id}
									stateName='selectedShippingRecord' />
								<Col sm={12}>
									<Button
										disabled={state.selectedShippingRecord ? false : true}
										onClick={handlers.onAddToParts}
										style={{ width: '100%' }}>
										{this.props.addBtnTitle || languageData['446'][languageCode]}
									</Button>
								</Col>
							</Row>
							:
							<Row>
								<Col sm={12}>
									<div style={{ fontWeight: "bold" }}>{languageData['442'][languageCode]}</div>
								</Col>
								<Col sm={12}>
									<Well style={{ paddingBottom: 5 }}>
										<Row>
											<Col sm={6}>
												<FormGroup controlId="partId">
													<ControlLabel style={{ marginBottom: 0 }}>{'產品編號'}</ControlLabel>
													<FormControl
														disabled={!editable}
														type='text'
														onChange={handlers.textInputOnChange}
														value={state.partId}
														style={{ height: 36 }} />
												</FormGroup>
											</Col>
											<Col sm={6}>
												<FormGroup controlId="partName">
													<ControlLabel style={{ marginBottom: 0 }}>{'品名規格'}</ControlLabel>
													<FormControl
														disabled={!editable}
														onChange={handlers.textInputOnChange}
														type='text'
														value={state.partName}
														style={{ height: 36 }} />
												</FormGroup>
											</Col>
										</Row>
									</Well>
								</Col>
								<Col sm={12}>
									<Button
										disabled={!(state.partId || state.partName)}
										onClick={this.handlers.searchPartsRealTime}
										style={{ width: '100%', marginTop: -10, marginBottom: 10 }}>
										{languageData['443'][languageCode]}
									</Button>
									<hr style={{ borderTop: '1px solid #ddd', marginTop: 0 }} />
								</Col>
								<Col sm={12}>
									<div style={{ fontWeight: "bold" }}>{`${languageData['444'][languageCode]} (產品編號/品名規格/建議售價/標準進價/停用日期)`}</div>
								</Col>
								<Col sm={12}>
									<Well style={{ marginBottom: 10 }}>
										<Row>
											<DropDownMenu
												id='part-search-results-dropdown'
												sm={12}
												options={state.optsSearchResults}
												onChange={handlers.dropDownOnChange}
												placeholder={state.dropDownPlaceholder}
												valueKey='product_id'
												value={state.selectedPart.product_id}
												stateName='selectedPart' />
										</Row>
									</Well>
								</Col>
								<Col sm={12}>
									<Button
										disabled={state.selectedPart ? false : true}
										onClick={handlers.onAddToParts}
										style={{ width: '100%' }}>
										{this.props.addBtnTitle || languageData['446'][languageCode]}
									</Button>
								</Col>
							</Row>
					}
			</Well>
		);
	}
}


// WEBPACK FOOTER //
// ./src/commonComponents/PartsSearchAreaCt.jsx